import { api } from '../lib/api';

export interface Supplier {
  id: number;
  name: string;
  isCompany: number | null;
  orgNr: string | null;
  vatNr: string | null;
  email: string | null;
  phone: string | null;
  website: string | null;
  address1: string | null;
  address2: string | null;
  postalCode: string | null;
  city: string | null;
  country: string | null;
  latitude: string | null;
  longitude: string | null;
  radiusM: number | null;
  notes: string | null;
  isActive: number;
}

export interface SupplierFormData {
  name: string;
  isCompany?: boolean | null;
  orgNr?: string;
  vatNr?: string;
  email?: string;
  phone?: string;
  website?: string;
  address1?: string;
  address2?: string;
  postalCode?: string;
  city?: string;
  country?: string;
  latitude?: string;
  longitude?: string;
  radiusM?: number | null;
  notes?: string;
  isActive?: boolean;
}

export const suppliersApi = {
  list: () => api.get<{ suppliers: Supplier[] }>('/suppliers'),
  get: (id: number) => api.get<Supplier>(`/suppliers/${id}`),
  create: (data: SupplierFormData) => api.post<{ id: number; name: string }>('/suppliers', data),
  update: (id: number, data: SupplierFormData) => api.patch<{ ok: boolean }>(`/suppliers/${id}`, data),
  delete: (id: number) => api.delete<{ ok: boolean }>(`/suppliers/${id}`),
};
